import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
/**
 * @file validate failed view
 * @author chenqiang(chenqiang03)
 */
import * as React from 'react';
import classNames from 'classnames';
import useMemo from "rc-util/es/hooks/useMemo";
import useCacheErrors from './hooks/useCacheErrors';
import useForceUpdate from '../_util/hooks/useForceUpdate';
import { FormItemPrefixContext } from './context';
var EMPTY_LIST = [];
export default function ErrorList(_ref) {
  var _ref$errors = _ref.errors,
    errors = _ref$errors === void 0 ? EMPTY_LIST : _ref$errors,
    help = _ref.help,
    onDomErrorVisibleChange = _ref.onDomErrorVisibleChange;
  var forceUpdate = useForceUpdate();
  var _React$useContext = React.useContext(FormItemPrefixContext),
    prefixCls = _React$useContext.prefixCls,
    status = _React$useContext.status;
  var _useCacheErrors = useCacheErrors(errors, function (changedVisible) {
      if (changedVisible) {
        Promise.resolve().then(function () {
          onDomErrorVisibleChange === null || onDomErrorVisibleChange === void 0 ? void 0 : onDomErrorVisibleChange(true);
        });
      }
      forceUpdate();
    }, !!help),
    _useCacheErrors2 = _slicedToArray(_useCacheErrors, 2),
    visible = _useCacheErrors2[0],
    cacheErrors = _useCacheErrors2[1];
  var memoErrors = useMemo(function () {
    return cacheErrors;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  visible, function (_, nextVisible) {
    return nextVisible;
  });
  // Memo status in same visible
  var _React$useState = React.useState(status),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    innerStatus = _React$useState2[0],
    setInnerStatus = _React$useState2[1];
  React.useEffect(function () {
    if (visible && status) {
      setInnerStatus(status);
    }
  }, [visible, status]);
  var baseClassName = "".concat(prefixCls, "-item-explain");
  return visible && /*#__PURE__*/React.createElement("div", {
    key: "help",
    className: classNames(baseClassName, _defineProperty({}, "".concat(baseClassName, "-").concat(innerStatus), innerStatus))
  }, memoErrors.map(function (error, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        key: index,
        role: "alert"
      }, error)
    );
  }));
}